import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Cap-height text trimming (CSS `text-box`). Figma trims every text box to cap
 * height, so its gaps are cap-to-cap; without this, CSS line boxes inflate all
 * vertical spacing. Chromium 133+/Safari 18.2+; Firefox degrades to slightly
 * looser spacing.
 */
export const CAP_TRIM = '[text-box-edge:cap_alphabetic] [text-box-trim:trim-both]';
